<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :return-value.sync="localTime"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-x
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :disabled="disabled"
        v-if="isRequired"
        :rules="[ruleRequired($t('utils:rules.required'))]"
        :value="computedTimeFormatted"
        :label="label"
        :hint="hint"
        :clearable="isClearable"
        persistent-hint
        outlined
        append-icon="schedule"
        @click:append="on.click"
        v-bind="attrs"
        class="mb-3"
        @click:clear="onClearClicked"
      />

      <v-text-field
        :disabled="disabled"
        v-else
        :value="computedTimeFormatted"
        :label="label"
        :hint="hint"
        :clearable="isClearable"
        persistent-hint
        outlined
        append-icon="schedule"
        v-on="on"
        @click:append="on.click"
        @click:clear="onClearClicked"
        class="mb-3"
      />
    </template>
    <v-time-picker
      :disabled="disabled"
      v-model="localTime"
      format="24hr"
      @input="changeTime"
    />
  </v-menu>
</template>

<script>
import {ruleRequired} from '@/modules/core/services/rules';
import DateUtils from "@/modules/core/services/date-utils";

export default {
  name: 'TimeField',
  props: {
    label: String,
    hint: String,
    isRequired: Boolean,
    isClearable: Boolean,
    disabled: Boolean,
    initTime: String

  },
  data() {
    return {
      menu: false,
      localTime: ''
    }
  },
  methods: {
    ruleRequired,

    onClearClicked() {
      this.localTime = null;
    },

    changeTime() {
      this.$refs.menu.save(this.localTime);
      this.$emit('update', this.localTime);
      this.menu = false;
    },

    reset() {
      Object.assign(this.$data, this.$options.data());
    },

    resetData() {
      this.reset();
      this.localTime = null;
      this.menu = false;
    },

    parseDTO(time) {
      this.localTime = DateUtils.parseTimeForVuetify(time);
      return this.localTime;
    }
  },
  computed: {
    computedTimeFormatted: {
      get() {
        if (this.localTime) {
          return this.localTime;
        }
        return null;
      },

      set(value) {
        this.$emit('update', value);
      }
    }
  },
  watch: {
    localTime() {
      this.computedTimeFormatted = this.localTime;
    }
  },
  created() {
    let initTime = !this.initTime;
    if (!initTime) {
      this.parseDTO(initTime);
    }
  }
}
</script>
